import { envVars } from "@/plugins/env-vars";

const _token = envVars.get("VUE_APP_DADATA_TOKEN");
const options: RequestInit = {
  method: "POST",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Token ${_token}`
  }
};

export const daDataService = {
  searchOrganizationByInn: async (query: string | undefined, count = 30) => {
    const url =
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party";
    const _options = {
      ...options,
      body: JSON.stringify({ query: query, count: count })
    };
    if (!_token) return;
    try {
      const response = await fetch(url, _options);
      const { suggestions } = await response?.json();
      return suggestions;
    } catch (e) {
      throw Error(e);
    }
  },

  searchBanksByBik: async (query: string | undefined, count = 20) => {
    let url =
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank";
    const _options = {
      ...options,
      body: JSON.stringify({ query: query, count: count })
    };
    if (!_token) return;
    try {
      const response = await fetch(url, _options);
      const { suggestions } = await response?.json();
      return suggestions;
    } catch (e) {
      throw Error(e);
    }
  }
};
